export default __webpack_public_path__ + "static/media/likes_filled_icon.e9c3c86a.svg";